module.exports = __webpack_public_path__ + "static/media/credits.81afffc2.svg";